// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import France from '../_raw/flag/icon_flag_france.png';

export default () => <img src={France} alt="France" />;
